<template>
  <div class="goodsTable">
    <!-- 运输载具数据表格 -->
    <vxe-toolbar v-if="['', '001', '003'].indexOf(baseData.statusFlag) != -1 && canEdit">
      <template v-slot:buttons>
        <vxe-button
          type="primary"
          icon="el-icon-plus"
          class="vxe-btn-primary"
          @click="insertEvent()"
          >{{ $t('returnDetail.btnList.add') }}</vxe-button
        >
        <vxe-button
          type="primary"
          icon="el-icon-delete"
          class="vxe-btn-delete"
          @click="handleDelete('goodsTable')"
          >{{ $t('returnDetail.btnList.remove') }}</vxe-button
        >
      </template>
    </vxe-toolbar>
    <vxe-grid
      border
      resizable
      show-overflow
      :data="goodsData"
      :columns="columnList"
      :edit-config="{ trigger: 'click', mode: 'row', activeMethod: this.activeRowMethod }"
      size="mini"
      ref="goodsTable"
      :edit-rules="goodsTableEditRules"
      auto-resize
      show-footer
      :footer-method="footerMethod"
    >
    </vxe-grid>
    <div style="margin-top: 16px">
      <SiruiSearch
        labelWidth="80px"
        :query="issue"
        :columns="issueColumn"
        :isQueryPanel="false"
      ></SiruiSearch>
    </div>

    <SelectTableDialog
      title="采购合同"
      :searchColumns="searchColumns"
      :columnList="contractColumnList"
      :defaultVisible="defaultVisible"
      :API="API"
      :extraData="extraData"
      :confirmUnchecked="false"
      :isMultiple="true"
      width="1200px"
      @close="close"
      @confirm="confirmContract"
    >
    </SelectTableDialog>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  // import SearchTable from '@/components/form-item/search-table';
  // import InputNumber from '@/components/form-item/input-number';
  // import GOODS_API from '@/api/masterData/goods';
  // import COOPERATION_API from '@/api/masterData/cooperation';
  // import MASTER_API from '@/api/masterData/company.js';
  // import API from '@/api/capitalCenter/letterOfCredit';
  // import { resolve, reject } from 'q';
  import SelectTableDialog from '@/components/SelectTableDialog';
  import SALE_API from '@/api/purchaseSalesCenter/purchaseSales.js';
  import XEUtils from 'xe-utils';
  import SiruiSearch from '@/components/SiruiSearch';
  export default {
    name: 'applicationTable',
    components: {
      // SearchTable,
      // InputNumber,
      SelectTableDialog,
      SiruiSearch,
    },
    props: ['type', 'validateApplicationForm', 'canEdit', 'getOverShortShippedPercentage'],
    data() {
      return {
        returnStatus: '',
        baseData: {
          statusFlag: '',
          partnerCode: '', //受益人
        },
        delList: [],
        goodsData: [],
        ladingNoLoading: false,
        ladingNoOptions: [], //提货仓库下拉数据
        defaultVisible: false,
        API: SALE_API.USER_LIST_API,
        issue: {
          issueRequire: '', // 开证要求
        },
        issueColumn: [
          {
            name: '开证要求',
            prop: 'issueRequire',
            type: 'textarea',
            span: 24,
            maxlength: 50,
          },
        ],
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      isWuMaoAccount() {
        return ['物贸', '国贸'].includes(this.userInfo.businessGroup);
      },
      goodsTableEditRules() {
        const issueQuantityRule = (rule, value, callback, { row }) => {
          let overShortShippedPercentage = this.$cal.calCommon(
            this.getOverShortShippedPercentage() || 0,
            100,
            '/'
          );
          let overSum = this.$cal.calCommon(
            row['purchaseQuantity'],
            overShortShippedPercentage,
            '*'
          );
          if (
            parseFloat(row['issueQuantity']) >
            this.$cal.calCommon(row['purchaseQuantity'], overSum, '+')
          ) {
            callback(new Error('实际数量不能大于数量+溢装量'));
          } else {
            /* else if(parseFloat(row['issueQuantity']) < this.$cal.calCommon(row['purchaseQuantity'],overSum,"-")){
          callback(new Error("实际数量不能小于数量-短装量"));
        } */
            callback();
          }
        };
        return {
          contractNo: [
            {
              required: true,
              message: this.$t('applicationDetail.goodsTable.contractNo'),
            },
          ],
          contractDetailNo: [
            {
              required: true,
              message: this.$t('applicationDetail.goodsTable.contractDetailNo'),
            },
          ],
          issueQuantity: [
            {
              required: true,
              message: this.$t('applicationDetail.goodsTable.issueQuantity'),
            },
            { validator: issueQuantityRule },
          ],
          issueAmount: [
            {
              required: true,
              message: this.$t('applicationDetail.goodsTable.issueAmount'),
            },
          ],
        };
      },
      columnList() {
        return [
          { type: 'checkbox', width: 50 },
          { title: this.$t('tFundCreditLetterContract.column.sortNo'), type: 'seq', width: 60 }, //序号
          {
            //项目
            field: 'projectCode',
            // title: '项目',
            title: '项目编号',
            width: 120,
            ...{
              editRender: { name: 'ElInput', props: { clearable: true } },
              slots: {
                default: ({ row }) => {
                  return [<span>{row.projectName}</span>];
                },
                edit: ({ row }) => {
                  if (this.isWuMaoAccount) {
                    return [
                      <search-table
                        searchType="projectListWumao"
                        isMultiple={true}
                        currentValue={row['projectName']}
                        checkRowKeys={[row['projectCode']]}
                        extraData={{
                          projectInitiationStatusList: ['PIS04', 'PIS05', 'PIS07', 'PIS08'],
                          applyCompanyNo: this.userInfo.companyCode,
                          applyCompanyName: this.userInfo.companyName,
                        }}
                        onInput={(val) => this.updateCol(row, val, 'projectCode')}
                      ></search-table>,
                    ];
                  } else {
                    return [
                      <search-table
                        searchType="project"
                        isMultiple={true}
                        currentValue={row['projectName']}
                        checkRowKeys={[row['projectCode']]}
                        onInput={(val) => this.updateCol(row, val, 'projectCode')}
                      ></search-table>,
                    ];
                  }
                },
              },
            },
          },
          {
            title: this.$t('tFundCreditLetterContract.column.contractNo'),
            field: 'contractNo',
            width: 180,
            editRender: { name: 'ElInput', props: { clearable: true } },
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [<span>{row.contractNo}</span>];
              },
              edit: ({ row }) => {
                return [
                  <search-table
                    searchType="contractHasDetail"
                    currentValue={row['contractNo']}
                    checkRowKeys={[row['contractNo']]}
                    isMultiple={true}
                    extraData={{
                      groupByContractDetailNoFlag: '1',
                      contractStatus: 'ZT03',
                      contractCategory: 'purchase',
                      supplierNo: this.baseData['partnerCode'],
                      customerNo: this.baseData.businessCompanyCode,
                      contractBusinessDepartment: this.baseData.businessDepartmentCode,
                      contractCurrency: this.baseData.currencyCode,
                      //receiptMethods: ['FK15','FK26']
                    }}
                    onInput={(val) => this.updateCol(row, val, 'contractNo')}
                  ></search-table>,
                ];
              },
            },
          }, //开证采购合同编码收证销售合同编号
          {
            title: this.$t('tFundCreditLetterContract.column.externalContractNo'),
            field: 'externalContractNo',
            width: 180,
          }, //外部合同号
          {
            title: this.$t('tFundCreditLetterContract.column.contractDetailNo'),
            field: 'contractDetailNo',
            width: 120,
            editRender: { name: 'ElInput', props: { clearable: true } },
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [<span>{row.contractDetailNo}</span>];
              },
              edit: ({ row }) => {
                return [
                  <search-table
                    searchType="contractHasDetail"
                    isMultiple={true}
                    currentValue={row['contractDetailNo']}
                    checkRowKeys={[row['contractDetailNo']]}
                    extraData={{
                      contractNo: row['contractNo'],
                    }}
                    onInput={(val) => this.updateCol(row, val, 'contractDetailNo')}
                  ></search-table>,
                ];
              },
            },
          }, //采购合同行项目编号
          {
            title: this.$t('tFundCreditLetterContract.column.productNo'),
            field: 'productNo',
            width: 120,
          }, //商品编码
          {
            title: this.$t('tFundCreditLetterContract.column.productDesc'),
            field: 'productDesc',
            width: 180,
          }, //商品描述
          //合同数量
          {
            title: '合同数量',
            field: 'purchaseQuantity',
            width: 120,
          },
          //开证数量
          {
            title: '开证数量',
            field: 'issueQuantity',
            width: 120,
            editRender: { name: 'ElInput', props: { clearable: true } },
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [<span>{row.issueQuantity}</span>];
              },
              edit: ({ row }) => {
                return [
                  <input-number
                    value={row['issueQuantity']}
                    placeholder={'开证数量'}
                    clearable={true}
                    precision={this.$globalVar.qPoint}
                    max={9999999999}
                    maxLength={10}
                    onInput={(val) => this.updateCol(row, val, 'issueQuantity')}
                  ></input-number>,
                ];
              },
            },
          },
          // {
          //   title: this.$t('tFundCreditLetterContract.column.purchaseQuantity'),
          //   field: 'purchaseQuantity',
          //   width: 120,
          // }, //采购数量
          // {
          //   title: this.$t('tFundCreditLetterContract.column.issueQuantity'),
          //   field: 'issueQuantity',
          //   width: 120,
          //   editRender: { name: 'ElInput', props: { clearable: true } },
          //   slots: {
          //     // 使用 JSX 渲染
          //     default: ({ row }) => {
          //       return [<span>{row.issueQuantity}</span>];
          //     },
          //     edit: ({ row }) => {
          //       return [
          //         <input-number
          //           value={row['issueQuantity']}
          //           placeholder={this.$t('tFundCreditLetterContract.column.issueQuantity')}
          //           clearable={true}
          //           precision={this.$globalVar.qPoint}
          //           max={9999999999}
          //           maxLength={10}
          //           onInput={(val) => this.updateCol(row, val, 'issueQuantity')}
          //         ></input-number>,
          //       ];
          //     },
          //   },
          // }, //实际数量
          {
            title: this.$t('tFundCreditLetterContract.column.businessContractUnitPrice'),
            field: 'businessContractUnitPrice',
            width: 120,
          }, //合同价格_合同单价(业务)
          {
            title: this.$t('tFundCreditLetterContract.column.businessContractTotalAmount'),
            field: 'businessContractTotalAmount',
            width: 120,
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [<span>{this.calCol(row, 'businessContractTotalAmount')}</span>];
              },
            },
          }, //总额
          {
            title: this.$t('tFundCreditLetterContract.column.issueAmount'),
            field: 'issueAmount',
            width: 120,
            editRender: { name: 'ElInput', props: { clearable: true } },
            slots: {
              // 使用 JSX 渲染
              // default: ({ row }) => {
              //   return [<span>{row.issueAmount}</span>];
              // },
              default: ({ row }) => {
                return [<span>{this.calAmountCol(row, 'issueAmount')}</span>];
              },
              edit: ({ row }) => {
                return [
                  <input-number
                    value={row['issueAmount']}
                    placeholder={this.$t('tFundCreditLetterContract.column.issueAmount')}
                    clearable={true}
                    precision={this.$globalVar.aPoint}
                    max={9999999999}
                    maxLength={10}
                    onInput={(val) => this.updateCol(row, val, 'issueAmount')}
                  ></input-number>,
                ];
              },
            },
          }, //本次开证金额/收证时认领金额
        ];
      },

      searchColumns() {
        return [
          {
            prop: 'contractNo',
            name: this.$t('salePurchase.search.contractNo'),
            type: 'input',
          },
        ];
      },
      contractColumnList() {
        return [
          {
            prop: 'contractNo',
            label: this.$t('salePurchase.search.contractNo'),
          },
          {
            prop: 'contractDetailNo',
            label: '合同行号',
          },
          {
            prop: 'productDesc',
            label: '商品描述',
          },
          {
            prop: 'productQuantity',
            label: '合同数量',
          },
          {
            prop: 'businessContractUnitPrice',
            label: '合同单价',
          },
          {
            prop: 'contractDetailCategoryName',
            label: this.$t('salePurchase.search.contractCategory'),
          },
          {
            prop: 'contractCreateDate',
            label: this.$t('salePurchase.table.contractCreateDate'),
          },
        ];
      },
      extraData() {
        return {
          contractStatus: 'ZT03',
          groupByContractDetailNoFlag: '1',
          contractCategory: 'purchase',
          supplierNo: this.baseData['partnerCode'],
          // receiptMethods: ['FK15','FK26'],
          // customerNo: this.baseData.businessCompanyCode,
          contractBusinessDepartment: this.baseData.businessDepartmentCode,
          contractCurrency: this.baseData.currencyCode,
          receiptMethods: ['016', '015'],
        };
      },
    },
    mounted() {},
    methods: {
      // 弹窗关闭
      close() {
        this.defaultVisible = false;
      },
      // 弹窗确认
      confirmContract(selections) {
        console.log(selections);
        // 不能出现相同的合同号+行号
        // sodo
        /**
       currentValue={row['projectName']}
                    checkRowKeys={[row['projectCode']]} */

        selections.map((item) => {
          const record = {
            contractNo: item.contractNo,
            contractDetailNo: item.contractDetailNo,
            externalContractNo: item.externalContractNo,
            issueQuantity: item.productQuantity,
            issueAmount: 0,
            productNo: item.productNo,
            productDesc: item.productDesc,
            projectName: item.projectName,
            projectCode: item.projectInitiationNo,
            businessContractUnitPrice: item.businessContractUnitPrice,
            purchaseQuantity: item.productQuantity,
            businessContractTotalAmount: this.$cal.calCommon(
              item.businessContractUnitPrice,
              item.productQuantity,
              '*',
              'amount'
            ),
          };
          this.$refs.goodsTable
            .insert(record, -1)
            .then(({ row }) => this.$refs.goodsTable.setActiveRow(row));
        });
        this.defaultVisible = false;
      },
      //JSX更新字段
      updateCol(row, val, type) {
        row[type] = val;
        if (type == 'contractNo' || type == 'contractDetailNo') {
          row['contractNo'] = val[0].contractNo;
          row['externalContractNo'] = val[0].externalContractNo;
          row.issueAmount = 0;
          row.contractDetailNo = val[0].contractDetailNo;
          row.productNo = val[0].productNo;
          row.productDesc = val[0].productDesc;
          row.issueQuantity = val[0].productQuantity;
          row.businessContractUnitPrice = val[0].businessContractUnitPrice;
          row.purchaseQuantity = val[0].productQuantity;
          row.businessContractTotalAmount = this.$cal.calCommon(
            row.businessContractUnitPrice,
            row.productQuantity,
            '*',
            'amount'
          );
          //todo 重置字段
        } else if (type == 'issueQuantity') {
          // 本次开证金额=实际数量*单价，可手工修改
          row['issueAmount'] = this.$cal.calCommon(
            row['issueQuantity'],
            row['businessContractUnitPrice'],
            '*',
            'amount'
          );
        } else if (type == 'projectCode') {
          if (val && val.length > 0) {
            row['projectName'] = val[0].projectName;
            row['projectCode'] = val[0].projectCode;
          } else {
            row['projectName'] = null;
            row['projectCode'] = null;
          }
        }
        this.$refs.goodsTable.updateFooter();
      },
      // 列属性含有计算公式
      calCol(row, type) {
        //总金额=数量*单价，不能手工修改
        if (type == 'businessContractTotalAmount') {
          row[type] = this.$cal.calCommon(
            row['purchaseQuantity'],
            row['businessContractUnitPrice'],
            '*',
            'amount'
          );
        }
        return row[type];
      },
      calAmountCol(row, type) {
        //本次开证金额=开证数量*单价，不能手工修改
        row[type] = this.$cal.calCommon(
          row['issueQuantity'],
          row['businessContractUnitPrice'],
          '*',
          'amount'
        );
        return row[type];
      },
      // 表尾合计
      footerMethod({ columns, data }) {
        {
          /* const that = this; */
        }
        return [
          columns.map((column) => {
            if (['issueAmount'].includes(column.property)) {
              let calculateIssuingAmount = XEUtils.calSum(data, column.property);
              this.$emit('calculateIssuingAmount', calculateIssuingAmount);
              return '合计:' + calculateIssuingAmount;
            }
            return null;
          }),
        ];
      },
      getDetail(allDetail) {
        this.baseData = allDetail;
        this.goodsData = allDetail.contractList;
        this.issue.issueRequire = allDetail.contractList[0].issueRequire || '';
      },
      activeRowMethod() {
        //禁用编辑
        if (['002', '004', '005', '006'].indexOf(this.baseData.statusFlag) != -1 || !this.canEdit) {
          return false;
        }
        return true;
      },
      // 载具表格新增一行
      insertEvent() {
        this.validateApplicationForm().then(() => {
          // 只能有一行合同信息
          // const list = this.$refs.goodsTable.getTableData().fullData;
          // if (list.length > 0) {
          //   return this.$message({
          //     showClose: true,
          //     message: '只能存在一行合同信息， 请先删除当前数据在新增数据',
          //     type: 'warning',
          //   });
          // }
          this.$refs.goodsTable.validate().then(() => {
            this.defaultVisible = true;
          });
        });
      },
      handleDelete(goodsTable) {
        const selectedList = this.$refs[goodsTable].getCheckboxRecords();
        if (selectedList.length < 1) {
          this.$message({
            showClose: true,
            message: this.$t('returnDetail.msg.removeMsg'),
            type: 'error',
          });
          return;
        }

        this.$confirmAction()
          .then(() => {
            this.$message({
              showClose: true,
              type: 'success',
              message: this.$t('message.delSuccess'),
            });
            selectedList.map((item) => {
              if (item.id) this.delList.push(item.id);
            });
            this.$refs['goodsTable'].removeSelecteds();
            this.goodsData = this.$refs['goodsTable'].getTableData().fullData;
            this.$refs['goodsTable'].updateFooter();
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },

      // 返回数据
      exportChildData() {
        return new Promise((resolve, reject) => {
          if (this.$refs.goodsTable.getTableData().fullData.length == 0) {
            this.$message({
              showClose: true,
              message: this.$t('applicationDetail.msg.goodsMsg'),
              type: 'error',
            });
            reject();
          } else {
            this.$refs['goodsTable']
              .validate()
              .then(() => {
                resolve();
              })
              .catch(() => {
                reject();
              });
          }
        });
      },
    },
  };
</script>
